<ion-content class="ion-padding">
  <div class="swiper-slide">
    <h1 #title>{{'points-received-component.strong'|translate}}</h1>
    <h2 #subtitle>
      <ion-chip>+ {{pointsReceived}}</ion-chip>
      {{'points-received-component.points-in-ranking' | translate}}</h2>
    <img class="thumb-animation" #fist src="assets/imgs/fist-bump.gif" alt="Fist bump"/></div>
</ion-content>
